import { render } from "./UpdateBucket.vue?vue&type=template&id=51eda887&scoped=true"
import script from "./UpdateBucket.vue?vue&type=script&lang=js"
export * from "./UpdateBucket.vue?vue&type=script&lang=js"

import "./UpdateBucket.vue?vue&type=style&index=0&id=51eda887&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51eda887"]])

export default __exports__